var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 67.38 95.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.14,95.49c-1.37,0-2.66-.53-3.63-1.5C.53,93.02,0,91.73,0,90.36.01,73.56.03,21.93.03,5.14.03,2.31,2.33.01,5.16.01c9.88,0,31.09,0,42.95-.01.5,0,.97.2,1.32.55,5.75,5.78,11.51,11.54,17.29,17.29.41.41.64.95.64,1.53-.01,20.19,0,57.21.02,70.98,0,1.37-.53,2.67-1.5,3.64-.97.97-2.26,1.51-3.64,1.51H5.14ZM8.53,5.29c-1.74,0-3.16,1.42-3.16,3.16v78.6c0,1.74,1.42,3.16,3.16,3.16h50.35c1.74,0,3.16-1.42,3.16-3.16V22.14h-16.89V5.29H8.53Zm49.56,11.55l-7.63-7.62v7.62h7.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.84,50.31v-5.56h-5.63v-5.25h6.57c1.45,0,2.89,0,4.33,0,1.57,0,2.85-1.07,3.1-2.58.24-1.39-.61-2.79-1.96-3.25-.46-.16-1-.17-1.43-.18-.55-.01-1.09-.02-1.64-.02h-1.03c-1.18,0-2.43,0-3.68-.14-4.08-.43-7.15-3.93-7.14-8.15.01-4.15,3.1-7.66,7.18-8.15.13-.02.73-.09,1.26-.16v-5.5h5.26v5.52h5.57v5.29h-6.84c-1.34,0-2.68,0-4.02,0-1.56.01-2.8.95-3.1,2.33-.31,1.45.38,2.84,1.69,3.4.46.19,1.02.3,1.71.31.56.01,1.12.02,1.68.02h2.09c.43,0,.86,0,1.3,0,4.55.07,8.15,3.41,8.37,7.76.22,4.53-2.97,8.2-7.6,8.72l-.83.08v5.52h-5.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.97,70.02c-1.4,0-2.55-1.14-2.55-2.55s1.14-2.57,2.55-2.57h39.47c1.4,0,2.55,1.14,2.55,2.55s-1.14,2.57-2.55,2.57H13.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.94,81.35c-1.4,0-2.55-1.14-2.55-2.55s1.14-2.57,2.55-2.57h39.49c1.4,0,2.55,1.14,2.55,2.55s-1.14,2.57-2.55,2.57H13.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.49,58.75c-1.4,0-2.55-1.14-2.55-2.55s1.14-2.55,2.55-2.55h16.96c1.4,0,2.55,1.14,2.55,2.55s-1.14,2.55-2.55,2.55h-16.96Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.dc21ee5efc82a8131a889a051dd39966.svg";
export { ForwardRef as ReactComponent };